import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import TextField from '@material-ui/core/TextField';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';

import LinearProgress from '~/components/LinearProgress';
import GridContainer from '~/components/GridContainer';
import GridItem from '~/components/GridItem';
import Pagination from '~/components/Table/Pagination';
import Button from '~/components/Button';

import Request from '~/providers/Request';
import toInt from '~/utils/Number/toInt';
import { editChat, createChat } from '~/config/routes';
import { URL } from '~/config/uri';

function ChatList({ history }) {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');

  const [chatList, setChatList] = useState([]);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const rowsPerPage = 20;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChat = async (row) => {
    history.push(editChat.reverse({ id: row.id }));
  };

  const fetchChats = async () => {
    setLoading(true);

    const response = await Request.get(
      '/admin/chats/closed',
      { qs: search, page: page, per_page: rowsPerPage },
      { normalizeJSON: false }
    );
    setLoading(false);
    setTotalPages(
      Math.ceil(toInt(response.meta.total) / response.meta.perPage)
    );
    setChatList(response.data);
  };

  useEffect(() => {
    fetchChats();
  }, [search, page]);

  useEffect(() => {
    setPage(1);
  }, [search]);

  return (
    <GridContainer justify="space-between">
      <GridItem xs={12} sm={9} md={9} lg={9} xl={9}>
        <TextField
          label="Buscar"
          variant="outlined"
          onChange={(event) => setSearch(event.target.value)}
          fullWidth
        />
      </GridItem>

      <GridItem>
        <Link style={{ textDecoration: 'none' }} to={createChat.spec}>
          <Button color="green">{t('action.new')}</Button>
        </Link>
      </GridItem>

      <LinearProgress loading={loading} />

      <GridItem xs={12} sm={12} md={9} lg={9} xl={9}>
        <List>
          {chatList.map((row) => {
            return (
              <div key={row.id}>
                <ListItem button onClick={() => handleChat(row)}>
                  <ListItemIcon>
                    <Avatar
                      src={`${URL}/public/user_face/${row?.uuid}.jpg?size=140`}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={row?.name}
                    secondary={`${t('chats.attributes.subject')}: ${
                      row?.subject
                    }`}
                  ></ListItemText>
                </ListItem>
                <Divider />
              </div>
            );
          })}
        </List>
      </GridItem>

      <LinearProgress loading={loading} />

      <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
        <Pagination
          count={totalPages}
          page={page}
          onChangePage={handleChangePage}
        />
      </GridItem>
    </GridContainer>
  );
}

export default React.memo(withRouter(ChatList));
